/**
 * Role dropdown labels — distinguish system vs institute-scoped roles with the same slug.
 */

export function formatRoleScopeBadge(role) {
  if (!role || typeof role !== "object") return "SYSTEM";
  if (role.isCustom || (role.instituteId != null && role.instituteId !== "")) {
    return "INSTITUTE";
  }
  return "SYSTEM";
}

export function formatRoleOptionLabel(role) {
  if (!role) return "";
  if (typeof role === "string") {
    const s = role.trim();
    if (!s) return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  const base =
    role.displayName ||
    role.name ||
    role.role ||
    role.slug ||
    "";
  const scope = formatRoleScopeBadge(role);
  const slug = String(role.slug || role.role || "").toLowerCase();
  const hasDuplicateHint = role.instituteId != null && role.instituteId !== "";
  if (hasDuplicateHint && slug) {
    const pretty = base || slug;
    return scope === "INSTITUTE" ? `${pretty} (Institute Custom)` : `${pretty} (System)`;
  }
  return base || slug;
}

export function roleOptionValue(role) {
  if (!role || typeof role !== "object") return String(role || "");
  if (role.id != null) return String(role.id);
  const slug = role.slug || role.role || "";
  const inst = role.instituteId != null ? String(role.instituteId) : "global";
  return `${slug}::${inst}`;
}

export function parseRoleOptionValue(value, rolesList = []) {
  const v = String(value || "");
  if (!v) return null;
  if (/^\d+$/.test(v)) {
    return rolesList.find((r) => String(r.id) === v) || { slug: v, role: v };
  }
  const [slug, inst] = v.split("::");
  if (inst && inst !== "global") {
    return (
      rolesList.find(
        (r) =>
          String(r.slug || r.role).toLowerCase() === slug.toLowerCase() &&
          String(r.instituteId) === inst
      ) || { slug, role: slug, instituteId: Number(inst) }
    );
  }
  return (
    rolesList.find(
      (r) =>
        String(r.slug || r.role).toLowerCase() === slug.toLowerCase() &&
        (r.instituteId == null || r.instituteId === "")
    ) || { slug, role: slug }
  );
}
